// utils/constants.js
const TARGET_STATE_ABBR = 'WI';

module.exports = {
  TARGET_STATE_ABBR,
};

